import Swiper from 'swiper';
import { Navigation, A11y, FreeMode } from 'swiper/modules';
import { animate } from '../../core/animations';

const updateBannerHeight = ($slider) => {
  if (window.theme.breakpoints.current === 'mobile') {
    $('.collection-smart-banner .collection-smart-banner__main').removeAttr('style');
    return;
  }
  
  const first_img_height = $slider.find('.collection-smart-banner-item').first().find('img').height();
  $('.collection-smart-banner .collection-smart-banner__main').height(first_img_height);
};

const initSlider = (slider) => {
  const total_slides = $(slider).find('.collection-smart-banner-item').length;

  const swiper = new Swiper(slider, {
    modules: [ Navigation, A11y, FreeMode ], // https://swiperjs.com/swiper-api#using-js-modules
    a11y: true,
    slidesPerView: total_slides > 3 ? 3.3 : 3,
    slidesPerGroup: 1,
    spaceBetween: 8,
    loop: true,
    loopAddBlankSlides: false,
    autoHeight: false,
    freeMode: true,
    autoplay: false,
    breakpoints: {
      769: {
        slidesPerView: 2.4,
        slidesPerGroup: 1,
        spaceBetween: 8,
        freeMode: false,
        autoHeight: false,
        navigation: {
          enabled: (total_slides > 3),
          nextEl: '.collection-smart-banner .swiper-button-next',
          prevEl: '.collection-smart-banner .swiper-button-prev',
        },
      },
      990: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 16,
        freeMode: false,
        autoHeight: false,
        navigation: {
          enabled: (total_slides > 3),
          nextEl: '.collection-smart-banner .swiper-button-next',
          prevEl: '.collection-smart-banner .swiper-button-prev',
        },
      },
    },
    on: {
      init: function () {
        updateBannerHeight($(slider));
        animate();
      },
    }
  });
};

export default () => {
  if (!$('.collection-smart-banner').length) {
    return;
  }

  const $slider = $('.collection-smart-banner .swiper');

  if (!$slider.length) {
    return;
  }

  initSlider($slider.get(0));

  $(window).on('resize', _.debounce(() => {
    updateBannerHeight($slider);
  }, 10));
};
